import type { VerifiedByAccessKey } from "../auth/access-keys/verified-by-access-key";
import { anonymizeHomeDelivery } from "../deliveries/home-deliveries/home-delivery";
import type { PhoneNumber } from "../phone";
import type { Order } from "./order";

const accessKeyVerifiedOrderFactory = (
    order: Order,
): VerifiedByAccessKey<Order> => {
    return {
        ...order,
        verifiedByAccessKey: true,
        contactInfo: {
            ...order.contactInfo,
            emailAddress: "",
            phoneNumber: "" as PhoneNumber,
            firstName: "********",
            lastName: "********",
            name: "********",
            image: undefined,
        },
        delivery: {
            ...(order.delivery._type === "HOME_DELIVERY"
                ? anonymizeHomeDelivery(order.delivery)
                : { ...order.delivery }),
        },
    };
};

export { accessKeyVerifiedOrderFactory };
